import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';

type BlInformationState = {
  filterSearchData: any;
  filterSearchTotal: number;
  loading: boolean;
  message: string;
  cargoDetail: any;
  success: boolean;
  consigneeNmBase: string;
  paramsBlDetailInfo: any;
};

const initialState: BlInformationState = {
  filterSearchData: [],
  filterSearchTotal: 0,
  message: '',
  loading: false,
  success: false,
  cargoDetail: {},
  consigneeNmBase: '',
  paramsBlDetailInfo: {
    strHblNo: '',
    rcvCnt: '',
    strCreSysIdH: '',
  },
};

export const blMasterSlice = createSlice({
  name: 'blMaster',
  initialState,
  reducers: {
    setParamsBlDetailInfo: (state, action) => {
      state.paramsBlDetailInfo = {
        strHblNo: action.payload.HBL_NO,
        rcvCnt: action.payload.RCV_CNT,
        strCreSysIdH: action.payload.CRE_SYS_ID_H,
      };
    },
    filterBlInformation: (state, action) => {
      state.loading = true;
    },
    filterBlInformationSuccess: (state, action) => {
      state.filterSearchData = action.payload.records;
      state.filterSearchTotal = action.payload.total;
      state.message = '';
      if (action.payload?.total === 0) {
        state.message = i18n.t('message.common.0001');
      }
      state.loading = false;
    },
    filterBlInformationFailure: (state, action) => {
      state.loading = action.payload.loading;
    },
    detailCargoInfo: (state, action) => {
      state.loading = true;
    },
    detailCargoInfoSuccess: (state, action) => {
      state.cargoDetail = action.payload.data;
      state.message = '';
      state.loading = false;
    },
    detailCargoInfoFailure: (state, action) => {
      state.message = action.payload.message;
      state.loading = action.payload.loading;
    },
    updateCargoInfor: (state, action) => {
      state.success = false;
      state.loading = true;
    },
    updateCargoInforSuccess: (state, action) => {
      state.cargoDetail = action.payload.data;
      state.success = true;
      state.loading = false;
    },
    updateCargoInforFailure: (state, action) => {
      state.success = false;
      state.loading = action.payload.loading;
    },
    cleanData: (state, action) => {
      state.success = action.payload?.success;
      state.cargoDetail = action.payload?.cargoDetail;
      state.filterSearchData = [];
      state.filterSearchTotal = 0;
      state.loading = false;
      state.message = '';
    },
    deleteCargoInfor: (state, action) => {
      state.success = false;
      state.loading = true;
    },
    deleteCargoInforSuccess: (state, action) => {
      state.success = true;
      state.loading = false;
    },
    deleteCargoInforFailure: (state, action) => {
      state.success = false;
      state.loading = action.payload.loading;
    },
    addCargoInfor: (state, action) => {
      state.success = false;
      state.loading = true;
    },
    addCargoInfoSuccess: (state, action) => {
      state.success = true;
      state.loading = false;
    },
    addCargoInfoFailure: (state, action) => {
      state.success = false;
      state.loading = action.payload.loading;
    },
    setValueConsigneeNmBase: (state, action) => {
      state.consigneeNmBase = action.payload;
    },
  },
});

export const {
  filterBlInformation,
  filterBlInformationSuccess,
  filterBlInformationFailure,
  detailCargoInfo,
  detailCargoInfoSuccess,
  detailCargoInfoFailure,
  updateCargoInfor,
  updateCargoInforSuccess,
  updateCargoInforFailure,
  cleanData,
  deleteCargoInfor,
  deleteCargoInforSuccess,
  addCargoInfor,
  addCargoInfoSuccess,
  deleteCargoInforFailure,
  addCargoInfoFailure,
  setValueConsigneeNmBase,
  setParamsBlDetailInfo,
} = blMasterSlice.actions;

export default blMasterSlice.reducer;
